import {
  httpGetJson as twHttpGetJson,
  httpGetText as twHttpGetText,
  httpPostJson as twHttpPostJson,
} from '@treatwell/ui';
import {ensureWafToken} from './ensureWafToken';

export async function httpGetJson<T>(
  params: Parameters<typeof twHttpGetJson>[0],
) {
  await ensureWafToken();
  return twHttpGetJson<T>(params);
}

export async function httpGetText<T = string>(
  params: Parameters<typeof twHttpGetText>[0],
) {
  await ensureWafToken();
  return twHttpGetText<T>(params);
}

export async function httpPostJson<T>(
  params: Parameters<typeof twHttpPostJson>[0],
) {
  await ensureWafToken();
  return twHttpPostJson<T>(params);
}
